import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cityCensusByPopulationReadAction from './cityCensusByPopulationRead.action.json'

const cityCensusByPopulationReadDefinition = defineReadAutoAction(
  cityCensusByPopulationReadAction,
  'cityCensusByPopulation',
)

export default cityCensusByPopulationReadDefinition
